import * as React from 'react';
import { hydrateRoot } from 'react-dom/client';

import { UiKitRoot } from '@cian/ui-kit';

import { IReduxStore } from '../../../shared/types/redux';
import { Application } from '../../../shared/containers/App';
import { IApplicationContext } from '../../../shared/types/applicationContext';

interface IDependencies {
  store: IReduxStore;
  context: IApplicationContext;
}

export function renderApplication(dependencies: IDependencies) {
  const { store, context } = dependencies;
  const {
    page: { deviceType },
  } = store.getState();

  const projectName = context.config.getStrict<string>('projectName');
  const rootElement = document.getElementById(projectName as string);

  if (!rootElement) {
    throw new Error(`Unable to find element #${projectName}`);
  }

  hydrateRoot(
    rootElement,
    <UiKitRoot deviceType={deviceType} useStaticDeviceType>
      <Application context={context} reduxStore={store} />
    </UiKitRoot>,
  );
}
